import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { noop } from 'lodash';

import Tree from 'react-checkbox-tree';
import KeyboardArrowDown from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';

import theme from './CheckboxTree.scss';

const propTypes = {
  rtl: PropTypes.bool,
  nodes: PropTypes.array,
  checked: PropTypes.array,
  expanded: PropTypes.array,
  className: PropTypes.string,
  singleSelection: PropTypes.bool,
  nativeSelect: PropTypes.bool,
  noCascade: PropTypes.bool,
  onChange: PropTypes.func,
};

const defaultProps = {
  rtl: false,
  nodes: [],
  checked: [],
  expanded: [],
  className: null,
  singleSelection: false,
  nativeSelect: true,
  noCascade: false,
  onChange: noop,
};

class CheckboxTree extends Component {

  constructor(props) {
    super(props);

    this.state = {
      checked: props.checked,
      expanded: props.expanded,
    };
  }

  onCheck = (checked, targetNode) => {
    const { singleSelection } = this.props;
    let newValue = checked;
    if (singleSelection) {
      newValue = targetNode.checked ? [targetNode.value] : [];
    }
    this.setState({ checked: newValue });
    this.props.onChange(!singleSelection ? newValue : newValue[0] || null);
  };

  onExpand = expanded => this.setState({ expanded });

  render() {
    const { checked, expanded } = this.state;
    const { rtl, className, nativeSelect, ...rest } = this.props;

    return (
      <div className={ classnames(theme.root, {
          [theme.customSelect]: !nativeSelect,
        }, className) }
      >
        <Tree
          { ...rest }
          checked={ checked }
          expanded={ expanded }
          onCheck={ this.onCheck }
          onExpand={ this.onExpand }
          icons={{
            expandClose: rtl ? <KeyboardArrowLeft /> : <KeyboardArrowRight />,
            expandOpen: <KeyboardArrowDown />,
          }}
        />
      </div>
    );
  }
}

CheckboxTree.propTypes = propTypes;
CheckboxTree.defaultProps = defaultProps;

export default CheckboxTree;
